import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { UserService } from "../shared/user.service";
import { FormBuilder, NgForm, Validators, FormGroup, FormControl } from "@angular/forms";
import { Form161FormalyService } from "../service/form161Formaly.service";
import {
  Form161Employee,
  Form161EmployeeContinuouslyWork,
  Form161EmployeeFundInstitution,
  Form161EmployeeRetirementGrantPayment,
  Form161Filter,
  Form161Header,
  FormalyStatus,
} from "../model/form161Formaly.model";
import { HttpErrorResponse } from "@angular/common/http";
import { SelectItem } from "primeng/primeng";
import { forEach } from "@angular/router/src/utils/collection";
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: "app-form161-formaly-employee",
  templateUrl: "./form161-formaly-employee.component.html",
  styleUrls: ["./form161-formaly-employee.component.css"],
  providers: [ConfirmationService]
})
export class Form161FormalyEmployeeComponent implements OnInit {

  @Output() onSaveEmployee = new EventEmitter<Form161Employee>();
  @Output() onSaveAndOrderEmployee = new EventEmitter<Form161Employee>();
  @Output() onSaveFunds = new EventEmitter<Form161Employee>();
  @Output() onReload = new EventEmitter<Form161Employee>();

  userDetails: any;
  enumFormalyStatus = FormalyStatus;
  
  actionType: string = null;

  employee: Form161Employee = null;
  dataForm161Header: Form161Header = null;
  customerAccountManagerEmail: string = null;

  msgs: any[];
  fundInstitutionsList: any[];
  resultsCities: string[];

  retirementReasonOptions: SelectItem[] = [
    {label: 'יציאה לגמלאות פיטורין או התפטרות', value: '1'},
    {label: 'פטירה', value: '2'},
    {label: 'נכות יציבה של 75%', value: '3'},
  ];

  completionCompensationHowOptions: SelectItem[] = [
    {label: 'מעסיק', value: 'מעסיק'},
    {label: 'קופה מרכזית לפיצויים', value: 'קופה מרכזית לפיצויים'},
    // {label: 'במסגרת הפקדה אחרונה', value: 'במסגרת הפקדה אחרונה'},
    // {label: 'מענק פרישה עקב פטירה', value: 'מענק פרישה עקב פטירה'},
    // {label: 'קצבה טרם פרישה', value: 'קצבה טרם פרישה'},
  ];

  payingCodeOptions: SelectItem[] = [
    {label: 'מעסיק', value: '1'},
    {label: 'מנהלת הגמלאות של עובדי המדינה', value: '2'},
    {label: 'קופה מרכזית לפיצויים', value: '3'},
    {label: 'קופת גמל לפיצויים', value: '4'},
    {label: 'קופת פנסיה ותיקה', value: '5'},
    {label: 'קופת גמל לקצבה', value: '6'},
  ]

  payingCodeOptionsOnlyEmp: SelectItem[] = [
    {label: 'מעסיק', value: '1'},
  ]  
  payingTypeOptions: SelectItem[] = [
    {label: 'מענק פרישה', value: '20'},
    {label: 'מענק כוחות הביטחון', value: '22'},
    {label: 'מענק פרישה עקב פטירה', value: '23'},
    {label: 'קצבה טרם פרישה', value: '30'},
  ]

  paymentsWithTaxesOptions: SelectItem[] = [
    {label: 'לא', value: '0'},
    {label: 'כן', value: '1'},
  ]

  is11aOptions: SelectItem[] = [
    {label: 'לא', value: '0'},
    {label: 'כן', value: '1'},
  ]

  yearRange: string = ((new Date()).getFullYear()-100).toString() + ':' + (new Date()).getFullYear().toString();
  yearRangeWithFuture: string = ((new Date()).getFullYear()-10).toString() + ':' + ((new Date()).getFullYear()+20).toString();


  employeeForm: FormGroup;
  get getEmployeeCellPhone(){return this.employeeForm.get('EmployeeCellPhone').value;}
  get getEmployeeMail(){return this.employeeForm.get('EmployeeMail').value;}
  get getEmployeeBirthDate(){return this.employeeForm.get('EmployeeBirthDate').value;}
  get getEmployeeCityName(){return this.employeeForm.get('EmployeeCityName').value;}
  get getEmployeeAddress(){return this.employeeForm.get('EmployeeAddress').value;}
  get getEmployeeBuilding(){return this.employeeForm.get('EmployeeBuilding').value;} 
  get getEmployeeZipCode(){return this.employeeForm.get('EmployeeZipCode').value;}   
  get getWorkPeriodStart(){return this.employeeForm.get('WorkPeriodStart').value;}   
  get getWorkPeriodEnd(){return this.employeeForm.get('WorkPeriodEnd').value;}   
  get getSallary(){return this.employeeForm.get('Sallary').value;}   
  get getLastSallary(){return this.employeeForm.get('LastSallary').value;}   
  get getSallaryHovatPizuim(){return this.employeeForm.get('SallaryHovatPizuim').value;}   
  get getRetirementReasonId(){return this.employeeForm.get('RetirementReasonId').value;}   
  get getisOwner(){return this.employeeForm.get('isOwner').value;}   
  get getisOwnerRelated(){return this.employeeForm.get('isOwnerRelated').value;}   
  get getOwnerRelation(){return this.employeeForm.get('OwnerRelation').value;}   
  get getisEntitledToBudgetPension(){return this.employeeForm.get('isEntitledToBudgetPension').value;}   
  get getEntitledToBudgetPensionFromDate(){return this.employeeForm.get('EntitledToBudgetPensionFromDate').value;}   
  get getEntitledToBudgetPensionSallary(){return this.employeeForm.get('EntitledToBudgetPensionSallary').value;}   
  get getisRetirementGrantPayment(){return this.employeeForm.get('isRetirementGrantPayment').value;}   
  get getisCompletionCompensation(){return this.employeeForm.get('isCompletionCompensation').value;}   
  get getCompletionCompensationHow(){return this.employeeForm.get('CompletionCompensationHow').value;}   
  get getCompletionCompensationPayingType(){return this.employeeForm.get('CompletionCompensationPayingType').value;}   
  get getCompletionCompensationPayingCode(){return this.employeeForm.get('CompletionCompensationPayingCode').value;}   
  get getCompletionCompensationPayingName(){return this.employeeForm.get('CompletionCompensationPayingName').value;}   
  get getCompletionCompensationTikNikuim(){return this.employeeForm.get('CompletionCompensationTikNikuim').value;}   
  get getCompletionCompensationAmount(){return this.employeeForm.get('CompletionCompensationAmount').value;}   
  get getCompletionCompensationPaymentDate(){return this.employeeForm.get('CompletionCompensationPaymentDate').value;}   
  get getCompletionCompensationHow2(){return this.employeeForm.get('CompletionCompensationHow2').value;}   
  get getCompletionCompensationPayingType2(){return this.employeeForm.get('CompletionCompensationPayingType2').value;}   
  get getCompletionCompensationPayingCode2(){return this.employeeForm.get('CompletionCompensationPayingCode2').value;}   
  get getCompletionCompensationPayingName2(){return this.employeeForm.get('CompletionCompensationPayingName2').value;}   
  get getCompletionCompensationTikNikuim2(){return this.employeeForm.get('CompletionCompensationTikNikuim2').value;}   
  get getCompletionCompensationAmount2(){return this.employeeForm.get('CompletionCompensationAmount2').value;}   
  get getCompletionCompensationPaymentDate2(){return this.employeeForm.get('CompletionCompensationPaymentDate2').value;}   

  get getisContinuouslyWork(){return this.employeeForm.get('isContinuouslyWork').value;}   

  getFundisPaymentsWithTaxes_N(id){if (id) {return this.phase2Form.get('FundisPaymentsWithTaxes_' + id).value==1?true:false;} else {return null;}}   
  getFundis11a_N(id){if (id) {return this.phase2Form.get('Fundis11a_' + id).value==1?true:false;} else {return null;}}   

  
  phase2Form: FormGroup;


  constructor(
    private userService: UserService,
    private form161FormalyService: Form161FormalyService,
    private fb: FormBuilder,
    private confirmationService: ConfirmationService
  ) {}

  ngOnInit() {

    this.userService.getUserClaims().subscribe((response) => {
      this.userDetails = response;
    },
    (err: HttpErrorResponse) => {
      this.showMessage('error', '', 'תקלה בקבלת פרטי משתמש');
    });


    this.employeeForm = this.fb.group({
      EmployeeCellPhone: ['', [Validators.required, Validators.pattern]],
      EmployeeMail: [''],
      EmployeeBirthDate: ['', Validators.required],
      EmployeeCityName: ['', Validators.required],
      EmployeeAddress: ['', Validators.required],
      EmployeeBuilding: [''],    
      EmployeeZipCode: ['',Validators.pattern],  
      WorkPeriodStart: ['', Validators.required],       
      WorkPeriodEnd: ['', Validators.required],       
      Sallary: ['', [Validators.required, Validators.pattern]],       
      LastSallary: ['', [Validators.required, Validators.pattern]],       
      SallaryHovatPizuim: ['', [Validators.required, Validators.pattern]],       
      RetirementReasonId: ['', Validators.required],       
      isOwner: [''],    
      isOwnerRelated: [''],    
      OwnerRelation: [''],    
      isEntitledToBudgetPension: [''],    
      EntitledToBudgetPensionFromDate: [''],    
      EntitledToBudgetPensionSallary: [''], 
      isRetirementGrantPayment: [''], 
      isCompletionCompensation: [''], 
      CompletionCompensationHow: [''], 
      CompletionCompensationTikNikuim: [''],
      CompletionCompensationPayingType: [''],
      CompletionCompensationPayingCode: [''],
      CompletionCompensationPayingName: [''],
      CompletionCompensationAmount: [''], 
      CompletionCompensationPaymentDate: [''],       
      CompletionCompensationHow2: [''], 
      CompletionCompensationTikNikuim2: [''],
      CompletionCompensationPayingType2: [''],
      CompletionCompensationPayingCode2: [''],
      CompletionCompensationPayingName2: [''],
      CompletionCompensationAmount2: [''], 
      CompletionCompensationPaymentDate2: [''], 
      isContinuouslyWork: [''], 
    });

    this.phase2Form = this.fb.group({

    });

  
  }

  fillData(employee: Form161Employee, dataForm161Header: Form161Header) {

    employee.FundInstitutions.forEach(e => {
      this.phase2Form.addControl('FundTikNikuim_' + e.RecordFundInstitutionId.toString(), new FormControl(e.TikNikuim));
      this.phase2Form.addControl('FundPayingName_' + e.RecordFundInstitutionId.toString(), new FormControl(e.PayingName));
      this.phase2Form.addControl('FundPayingCode_' + e.RecordFundInstitutionId.toString(), new FormControl(e.PayingCode));
      this.phase2Form.addControl('FundPayingType_' + e.RecordFundInstitutionId.toString(), new FormControl(e.PayingType));
      this.phase2Form.addControl('FundFirstPaymentDate_' + e.RecordFundInstitutionId.toString(), new FormControl(e.FirstPaymentDate?(new Date(e.FirstPaymentDate)):null));
      this.phase2Form.addControl('FundLastPaymentDate_' + e.RecordFundInstitutionId.toString(), new FormControl(e.LastPaymentDate?(new Date(e.LastPaymentDate)):null));
      this.phase2Form.addControl('FundAmountAtRetirement9a_' + e.RecordFundInstitutionId.toString(), new FormControl(e.AmountAtRetirement9a));
      this.phase2Form.addControl('FundAdditionalAccumulation9a_' + e.RecordFundInstitutionId.toString(), new FormControl(e.AdditionalAccumulation9a));
      
      this.phase2Form.addControl('FundisPaymentsWithTaxes_' + e.RecordFundInstitutionId.toString(), new FormControl(e.isPaymentsWithTaxes));
      this.phase2Form.addControl('FundPaymentsWithTaxes_' + e.RecordFundInstitutionId.toString(), new FormControl(e.PaymentsWithTaxes));
      this.phase2Form.addControl('FundPaymentsWithTaxesIncludeProfit_' + e.RecordFundInstitutionId.toString(), new FormControl(e.PaymentsWithTaxesIncludeProfit));

      this.phase2Form.addControl('Fundis11a_' + e.RecordFundInstitutionId.toString(), new FormControl(e.is11a));
      this.phase2Form.addControl('FundAmountAtRetirement11a_' + e.RecordFundInstitutionId.toString(), new FormControl(e.AmountAtRetirement11a));
      this.phase2Form.addControl('FundAdditionalAccumulation11a_' + e.RecordFundInstitutionId.toString(), new FormControl(e.AdditionalAccumulation11a));

    });

    


    this.employee = employee;
    this.dataForm161Header = dataForm161Header;
    this.customerAccountManagerEmail = dataForm161Header.CustomerAccountManagerEmail;

   

    this.employeeForm.patchValue({
      EmployeeCellPhone: this.employee.EmployeeCellPhone,
      EmployeeMail: this.employee.EmployeeMail,
      EmployeeBirthDate: this.employee.EmployeeBirthDate?new Date(this.employee.EmployeeBirthDate):null,
      EmployeeCityName: this.employee.EmployeeCityName,
      EmployeeAddress: this.employee.EmployeeAddress,
      EmployeeBuilding: this.employee.EmployeeBuilding,
      EmployeeZipCode: this.employee.EmployeeZipCode,
      WorkPeriodStart: this.employee.WorkPeriodStart?new Date(this.employee.WorkPeriodStart):null,
      WorkPeriodEnd: this.employee.WorkPeriodEnd?new Date(this.employee.WorkPeriodEnd):null,
      Sallary: this.employee.Sallary,
      LastSallary: this.employee.LastSallary,
      SallaryHovatPizuim: this.employee.SallaryHovatPizuim,
      RetirementReasonId: this.employee.RetirementReasonId,
      isOwner: this.employee.isOwner,
      isOwnerRelated: this.employee.isOwnerRelated,
      OwnerRelation: this.employee.OwnerRelation,
      isEntitledToBudgetPension: this.employee.isEntitledToBudgetPension,
      EntitledToBudgetPensionFromDate: this.employee.EntitledToBudgetPensionFromDate?new Date(this.employee.EntitledToBudgetPensionFromDate):null,
      EntitledToBudgetPensionSallary: this.employee.EntitledToBudgetPensionSallary,
      isRetirementGrantPayment: this.employee.isRetirementGrantPayment,
      isCompletionCompensation: this.employee.isCompletionCompensation,
      CompletionCompensationHow: this.employee.CompletionCompensationHow,
      CompletionCompensationPayingType: this.employee.CompletionCompensationPayingType,
      CompletionCompensationPayingCode: this.employee.CompletionCompensationPayingCode,
      CompletionCompensationPayingName: this.employee.CompletionCompensationPayingName,
      CompletionCompensationTikNikuim: this.employee.CompletionCompensationTikNikuim,
      CompletionCompensationAmount: this.employee.CompletionCompensationAmount,
      CompletionCompensationPaymentDate: this.employee.CompletionCompensationPaymentDate?new Date(this.employee.CompletionCompensationPaymentDate):null,      
      CompletionCompensationHow2: this.employee.CompletionCompensationHow2,
      CompletionCompensationPayingType2: this.employee.CompletionCompensationPayingType2,
      CompletionCompensationPayingCode2: this.employee.CompletionCompensationPayingCode2,
      CompletionCompensationPayingName2: this.employee.CompletionCompensationPayingName2,
      CompletionCompensationTikNikuim2: this.employee.CompletionCompensationTikNikuim2,
      CompletionCompensationAmount2: this.employee.CompletionCompensationAmount2,
      CompletionCompensationPaymentDate2: this.employee.CompletionCompensationPaymentDate2?new Date(this.employee.CompletionCompensationPaymentDate2):null,      
      isContinuouslyWork: this.employee.isContinuouslyWork,
    });

    if (this.isReadonly()) {
      this.employeeForm.controls['isOwner'].disable();
      this.employeeForm.controls['isOwnerRelated'].disable();
      this.employeeForm.controls['isEntitledToBudgetPension'].disable();
      this.employeeForm.controls['isRetirementGrantPayment'].disable();
      this.employeeForm.controls['isCompletionCompensation'].disable();
      this.employeeForm.controls['isContinuouslyWork'].disable();


    }


    
    if (!employee.isContinuouslyWork && employee.ContinuouslyWorks && employee.ContinuouslyWorks.length>0) {
      //this.addContinuouslyWork(0);
      let newIndex: number = 0;
      employee.ContinuouslyWorks.forEach(e => {
        this.employeeForm.addControl('ContinuouslyWorkPeriodFrom_' + newIndex.toString(), new FormControl(''));
        this.employeeForm.addControl('ContinuouslyWorkPeriodTo_' + newIndex.toString(), new FormControl(''));
        this.employeeForm.addControl('ContinuouslyWorkSallary_' + newIndex.toString(), new FormControl(''));
        this.employeeForm.addControl('ContinuouslyWorkPositionPercent_' + newIndex.toString(), new FormControl(''));
        this.employeeForm.patchValue({
          ['ContinuouslyWorkPeriodFrom_' + newIndex.toString()]: employee.ContinuouslyWorks[newIndex].PeriodFrom?new Date(employee.ContinuouslyWorks[newIndex].PeriodFrom):null,
          ['ContinuouslyWorkPeriodTo_' + newIndex.toString()]: employee.ContinuouslyWorks[newIndex].PeriodTo?new Date(employee.ContinuouslyWorks[newIndex].PeriodTo):null,
          ['ContinuouslyWorkSallary_' + newIndex.toString()]: employee.ContinuouslyWorks[newIndex].Sallary,
          ['ContinuouslyWorkPositionPercent_' + newIndex.toString()]:employee.ContinuouslyWorks[newIndex].PositionPercent,
        });
        newIndex++;
      });
      
      this.addContinuouslyWork(null);
    }


    if (employee.isRetirementGrantPayment && employee.RetirementGrantPayments && employee.RetirementGrantPayments.length) {
      let newIndex: number = 0;
      employee.RetirementGrantPayments.forEach(e => {
        this.employeeForm.addControl('RetirementGrantPaymentsPaymentDate_' + newIndex.toString(), new FormControl(''));
        this.employeeForm.addControl('RetirementGrantPaymentsPayment_' + newIndex.toString(), new FormControl(''));
        this.employeeForm.patchValue({
          ['RetirementGrantPaymentsPaymentDate_' + newIndex.toString()]: employee.RetirementGrantPayments[newIndex].PaymentDate?new Date(employee.RetirementGrantPayments[newIndex].PaymentDate):null,
          ['RetirementGrantPaymentsPayment_' + newIndex.toString()]:employee.RetirementGrantPayments[newIndex].Payment,
        });
        newIndex++;
      });
      
      this.addRetirementGrantPayment(null);
    }






  }

  set10aDisabled(id) {
    if (this.getFundisPaymentsWithTaxes_N(id)) {
      this.phase2Form.controls['FundPaymentsWithTaxes_'+id].enable();
      this.phase2Form.controls['FundPaymentsWithTaxesIncludeProfit_'+id].enable();
    } else {
      this.phase2Form.controls['FundPaymentsWithTaxes_'+id].disable();
      this.phase2Form.controls['FundPaymentsWithTaxesIncludeProfit_'+id].disable();
    }
  }

  set11aDisabled(id) {
    if (this.getFundis11a_N(id)) {
      this.phase2Form.controls['FundAmountAtRetirement11a_'+id].enable();
      this.phase2Form.controls['FundAdditionalAccumulation11a_'+id].enable();
    } else {
      this.phase2Form.controls['FundAmountAtRetirement11a_'+id].disable();
      this.phase2Form.controls['FundAdditionalAccumulation11a_'+id].disable();
    }
  }

  showMessage(type, summaryMessage, message): void {
    this.msgs = [];
    this.msgs.push({
      severity: type,
      summary: summaryMessage,
      detail: message,
    });
  }

  searchCity(event) {
    this.form161FormalyService.GetCityesList(event.query).subscribe((data) => {
      this.resultsCities = data;

    });
  }

  onSubmit(form: FormGroup) {
    //console.log(this.getEmployeeCityName);

    //1. collect data
    //2. validate employee data
    //3. emit to parent for validate customer data and save

    let employee: Form161Employee = this.clone(this.employee);

    // 1. collect data
    employee.EmployeeCellPhone = this.getEmployeeCellPhone;
    employee.EmployeeMail = this.getEmployeeMail;
    employee.EmployeeBirthDate = this.getEmployeeBirthDate?this.datePrepare(this.getEmployeeBirthDate):null;
    employee.EmployeeCityName = this.getEmployeeCityName;
    employee.EmployeeAddress = this.getEmployeeAddress;
    employee.EmployeeBuilding = this.getEmployeeBuilding;
    employee.EmployeeZipCode = this.getEmployeeZipCode;
    employee.WorkPeriodStart = this.getWorkPeriodStart?this.datePrepare(this.getWorkPeriodStart):null;
    employee.WorkPeriodEnd = this.getWorkPeriodEnd?this.datePrepare(this.getWorkPeriodEnd):null;
    employee.Sallary = this.getSallary;
    employee.LastSallary = this.getLastSallary;
    employee.SallaryHovatPizuim = this.getSallaryHovatPizuim;
    employee.RetirementReasonId = Number(this.getRetirementReasonId);
    employee.isOwner = this.getisOwner;

    employee.isOwnerRelated = this.getisOwnerRelated;
    if (employee.isOwnerRelated) {
      employee.OwnerRelation = this.getOwnerRelation;
    } else {
      employee.OwnerRelation = null;
    }

    employee.isEntitledToBudgetPension = this.getisEntitledToBudgetPension;
    if (employee.isEntitledToBudgetPension) {
      employee.EntitledToBudgetPensionFromDate = this.getEntitledToBudgetPensionFromDate?this.datePrepare(this.getEntitledToBudgetPensionFromDate):null;
      employee.EntitledToBudgetPensionSallary = this.getEntitledToBudgetPensionSallary;
    } else {
      employee.EntitledToBudgetPensionFromDate = null;
      employee.EntitledToBudgetPensionSallary = null;
    }

    employee.isCompletionCompensation = this.getisCompletionCompensation;
    if (this.getisCompletionCompensation) {
      employee.CompletionCompensationHow = this.getCompletionCompensationHow;
      employee.CompletionCompensationPayingType = this.getCompletionCompensationPayingType;
      employee.CompletionCompensationPayingCode = this.getCompletionCompensationPayingCode;
      employee.CompletionCompensationPayingName = this.getCompletionCompensationPayingName;
      employee.CompletionCompensationTikNikuim = this.getCompletionCompensationTikNikuim;
      employee.CompletionCompensationAmount = this.getCompletionCompensationAmount;
      employee.CompletionCompensationPaymentDate = this.getCompletionCompensationPaymentDate?this.datePrepare(this.getCompletionCompensationPaymentDate):null;      
      employee.CompletionCompensationHow2 = this.getCompletionCompensationHow2;
      employee.CompletionCompensationPayingType2 = this.getCompletionCompensationPayingType2;
      employee.CompletionCompensationPayingCode2 = this.getCompletionCompensationPayingCode2;
      employee.CompletionCompensationPayingName2 = this.getCompletionCompensationPayingName2;
      employee.CompletionCompensationTikNikuim2 = this.getCompletionCompensationTikNikuim2;
      employee.CompletionCompensationAmount2 = this.getCompletionCompensationAmount2;
      employee.CompletionCompensationPaymentDate2 =  this.getCompletionCompensationPaymentDate2?this.datePrepare(this.getCompletionCompensationPaymentDate2):null;      
    } else {
      employee.CompletionCompensationHow = null;
      employee.CompletionCompensationPayingType = null;
      employee.CompletionCompensationPayingCode = null;
      employee.CompletionCompensationPayingName = null;
      employee.CompletionCompensationTikNikuim = null;
      employee.CompletionCompensationAmount = null;
      employee.CompletionCompensationPaymentDate = null;
      employee.CompletionCompensationHow2 = null;
      employee.CompletionCompensationPayingType2 = null;
      employee.CompletionCompensationPayingCode2 = null;
      employee.CompletionCompensationPayingName2 = null;
      employee.CompletionCompensationTikNikuim2 = null;
      employee.CompletionCompensationAmount2 = null;
      employee.CompletionCompensationPaymentDate2 = null;
    }

    employee.isRetirementGrantPayment = this.getisRetirementGrantPayment;
    employee.RetirementGrantPayments = [];
    if (employee.isRetirementGrantPayment) {
      for (let i = 0; i < this.employee.RetirementGrantPayments.length; i++) {
          if (i<this.employee.RetirementGrantPayments.length-1) {
            // this is not last item
            //employee.RetirementGrantPayments.push(this.clone(this.employee.RetirementGrantPayments[i]));
            let rgpd = this.employeeForm.get('RetirementGrantPaymentsPaymentDate_' + i.toString()).value;
            let valueDate:Date = rgpd?this.datePrepare(rgpd):null;
            let valueSallary:number = this.employeeForm.get('RetirementGrantPaymentsPayment_' + i.toString()).value;
            let item: Form161EmployeeRetirementGrantPayment = {
              RetirementGrantPaymentId: null,
              Payment: valueSallary,
              PaymentDate: valueDate
            };
            employee.RetirementGrantPayments.push(item);
          } else {
            // this is last item 
            let rgpd = this.employeeForm.get('RetirementGrantPaymentsPaymentDate_' + i.toString()).value;
            let valueDate:Date = rgpd?this.datePrepare(rgpd):null;
            let valueSallary:number = this.employeeForm.get('RetirementGrantPaymentsPayment_' + i.toString()).value;
            if (!valueDate && !valueSallary) {
              // empty values, no need to be added
            } else if (valueDate && valueSallary) {
              let item: Form161EmployeeRetirementGrantPayment = {
                RetirementGrantPaymentId: null,
                Payment: valueSallary,
                PaymentDate: valueDate
              };
              employee.RetirementGrantPayments.push(item);
            } else {
              // one of 2 valus is empty
              this.showMessage("error", "", "חובה למלא את תאריך וסכום התשלום במענק פרישה אחרון שהוזן");
              return;
            }
          }
      }
    }

    employee.isContinuouslyWork = this.getisContinuouslyWork;
    employee.ContinuouslyWorks = [];
    if (!employee.isContinuouslyWork) {
      for (let i = 0; i < this.employee.ContinuouslyWorks.length; i++) {
          if (i<this.employee.ContinuouslyWorks.length-1) {
            // this is not last item
            //employee.ContinuouslyWorks.push(this.clone(this.employee.ContinuouslyWorks[i]));
            let pf = this.employeeForm.get('ContinuouslyWorkPeriodFrom_' + i.toString()).value;
            let valueDateFrom:Date = pf?this.datePrepare(pf):null;
            let pt = this.employeeForm.get('ContinuouslyWorkPeriodTo_' + i.toString()).value;
            let valueDateTo:Date = pt?this.datePrepare(pt):null;
            let valueSallary:number = this.employeeForm.get('ContinuouslyWorkSallary_' + i.toString()).value;
            let valuePositionPercent:number = this.employeeForm.get('ContinuouslyWorkPositionPercent_' + i.toString()).value;
            let item: Form161EmployeeContinuouslyWork = {
              ContinuouslyWorkId: null,
              PeriodFrom: valueDateFrom,
              PeriodTo: valueDateTo,
              Sallary: valueSallary,
              PositionPercent: valuePositionPercent,
            };
            employee.ContinuouslyWorks.push(item);
          } else {
            // this is last item 
            let pf = this.employeeForm.get('ContinuouslyWorkPeriodFrom_' + i.toString()).value;
            let valueDateFrom:Date = pf?this.datePrepare(pf):null;
            let pt = this.employeeForm.get('ContinuouslyWorkPeriodTo_' + i.toString()).value;
            let valueDateTo:Date = pt?this.datePrepare(pt):null;
            let valueSallary:number = this.employeeForm.get('ContinuouslyWorkSallary_' + i.toString()).value;
            let valuePositionPercent:number = this.employeeForm.get('ContinuouslyWorkPositionPercent_' + i.toString()).value;
            if (!valueDateFrom && !valueDateTo && !valueSallary && !valuePositionPercent) {
              // empty values, no need to be added
            } else if (valueDateFrom && valueDateTo && valueSallary && valuePositionPercent) {
              let item: Form161EmployeeContinuouslyWork = {
                ContinuouslyWorkId: null,
                PeriodFrom: valueDateFrom,
                PeriodTo: valueDateTo,
                Sallary: valueSallary,
                PositionPercent: valuePositionPercent,
              };
              employee.ContinuouslyWorks.push(item);
            } else {
              // one of 4 valus is empty
              this.showMessage("error", "", "חובה למלא את כל הפרטים בהיקף משרה בתקופה אחרונה שהוזנה");
              return;
            }
          }
      }
    }


    // 2. validation
    let specialValidated=true;
    let messagesSpecialValidation: string[] = [];

    if (this.getisOwnerRelated) {
      if (!this.getOwnerRelation || this.getOwnerRelation=='' || this.getOwnerRelation.trim()=='') {
        specialValidated = false;
        messagesSpecialValidation.push("חובה למלא שדה 'הקירבה' כאשר נבחר 'העובד קרוב של בעל השליטה במעסיק?'");
        //this.showMessage("error", "", "חובה למלא שדה 'הקירבה' כאשר נבחר 'העובד קרוב של בעל השליטה במעסיק?'");
      }
    }

    if (this.getisRetirementGrantPayment) {
      if (!employee.RetirementGrantPayments || employee.RetirementGrantPayments.length == 0) {
        specialValidated = false;
        messagesSpecialValidation.push("חובה למלא פרטי תשלום אחד לפחות כאשר נבחר 'תשלום מענק פרישה'");
        //this.showMessage("error", "", "חובה למלא פרטי תשלום אחד לפחות כאשר נבחר 'תשלום מענק פרישה'");
      }
    }

    if (this.getisCompletionCompensation) {
      if ((!this.getCompletionCompensationHow || this.getCompletionCompensationHow=='') && (!this.getCompletionCompensationHow2 || this.getCompletionCompensationHow2=='')) {
        specialValidated = false;
        messagesSpecialValidation.push("חובה למלא 'כיצד' לפחות באפשרות אחת כאשר נבחר 'השלמת פיצויים'");
        //this.showMessage("error", "", "חובה למלא 'כיצד' לפחות באפשרות אחת כאשר נבחר 'השלמת פיצויים'");
      }
      if (this.getCompletionCompensationHow) {
        if ( 
          (!this.getCompletionCompensationPayingName || this.getCompletionCompensationPayingName=='') ||
          (!this.getCompletionCompensationPayingType || this.getCompletionCompensationPayingType=='') ||
          (!this.getCompletionCompensationPayingCode || this.getCompletionCompensationPayingCode=='') ||
          (!this.getCompletionCompensationTikNikuim || this.getCompletionCompensationTikNikuim=='') ||
          (!this.getCompletionCompensationAmount || this.getCompletionCompensationAmount=='') ||
          (!this.getCompletionCompensationPaymentDate)
        ) {
        specialValidated = false;
        messagesSpecialValidation.push("חובה למלא את כל השדות בשורה כאשר בהשלמת פיצויים נבחר ,כיצד,'");
        //this.showMessage("error", "", "חובה למלא את כל השדות בשורה כאשר בהשלמת פיצויים נבחר ,כיצד,'");
        }
      }
      if (this.getCompletionCompensationHow2) {
        if ( 
          (!this.getCompletionCompensationPayingName2 || this.getCompletionCompensationPayingName2=='') ||
          (!this.getCompletionCompensationPayingType2 || this.getCompletionCompensationPayingType2=='') ||
          (!this.getCompletionCompensationPayingCode2 || this.getCompletionCompensationPayingCode2=='') ||
          (!this.getCompletionCompensationTikNikuim2 || this.getCompletionCompensationTikNikuim2=='') ||
          (!this.getCompletionCompensationAmount2 || this.getCompletionCompensationAmount2=='') ||
          (!this.getCompletionCompensationPaymentDate2)
        ) {
        specialValidated = false;
        messagesSpecialValidation.push("חובה למלא את כל השדות בשורה כאשר בהשלמת פיצויים נבחר ,כיצד,'");
        //this.showMessage("error", "", "חובה למלא את כל השדות בשורה כאשר בהשלמת פיצויים נבחר ,כיצד,'");
        }
      }
    }

    if (!this.getisContinuouslyWork) {
      if (!employee.ContinuouslyWorks || employee.ContinuouslyWorks.length == 0) {
        specialValidated = false;
        messagesSpecialValidation.push("חובה למלא פרטי תקופה אחת לפחות כאשר לא מסומן 'האם העובד עבד באופן רציף'");
        //this.showMessage("error", "", "חובה למלא פרטי תקופה אחת לפחות כאשר לא מסומן 'האם העובד עבד באופן רציף'");
      }
    }




    // console.log('--------');
    // console.log(this.employeeForm.valid);
    // console.log(specialValidated);

    if (!this.employeeForm.valid) {
      this.showMessage("error", "", "נא למלא את שדות החובה ובפורמט התקין");
      return;
    }

    if (!specialValidated && this.actionType=='order') {
      messagesSpecialValidation.forEach(m=> {
        this.showMessage("error", "", m);
      });
      return;
    }

    if (this.actionType=='draft') {
      this.onSaveEmployee.emit(employee);
    } else if (this.actionType=='order') {
      this.onSaveAndOrderEmployee.emit(employee);
    } else {
      this.showMessage("error", "", "פעולה לא חוקית");
    }



  }

  onSubmitPhase2Form(form: FormGroup) {

    if (!this.phase2Form.valid) {
      this.showMessage("error", "", "נא למלא כל שדות החובה ולוודא מילוי ערכים בפורמט תקין");
      return;
    }

    let employee: Form161Employee = this.clone(this.employee);

    // collect data

    employee.FundInstitutions.forEach(e => {
      e.TikNikuim = this.phase2Form.get('FundTikNikuim_' + e.RecordFundInstitutionId).value;
      e.PayingName = this.phase2Form.get('FundPayingName_' + e.RecordFundInstitutionId).value;
      e.PayingCode = this.phase2Form.get('FundPayingCode_' + e.RecordFundInstitutionId).value;
      e.PayingType = this.phase2Form.get('FundPayingType_' + e.RecordFundInstitutionId).value;
      let fpd = this.phase2Form.get('FundFirstPaymentDate_' + e.RecordFundInstitutionId).value;
      e.FirstPaymentDate = fpd?this.datePrepare(fpd):null;
      let lpd = this.phase2Form.get('FundLastPaymentDate_' + e.RecordFundInstitutionId).value;
      e.LastPaymentDate = lpd?this.datePrepare(lpd):null;
      e.AmountAtRetirement9a = this.phase2Form.get('FundAmountAtRetirement9a_' + e.RecordFundInstitutionId).value;
      e.AdditionalAccumulation9a = this.phase2Form.get('FundAdditionalAccumulation9a_' + e.RecordFundInstitutionId).value;
      let tmp10 = this.phase2Form.get('FundisPaymentsWithTaxes_' + e.RecordFundInstitutionId).value;
      e.isPaymentsWithTaxes = (tmp10 && tmp10=='1')?true:false;
      e.PaymentsWithTaxes = this.phase2Form.get('FundPaymentsWithTaxes_' + e.RecordFundInstitutionId).value;
      e.PaymentsWithTaxesIncludeProfit = this.phase2Form.get('FundPaymentsWithTaxesIncludeProfit_' + e.RecordFundInstitutionId).value;
      let tmp11 = this.phase2Form.get('Fundis11a_' + e.RecordFundInstitutionId).value;
      e.is11a = (tmp11 && tmp11=='1')?true:false;
      e.AmountAtRetirement11a = this.phase2Form.get('FundAmountAtRetirement11a_' + e.RecordFundInstitutionId).value;
      e.AdditionalAccumulation11a = this.phase2Form.get('FundAdditionalAccumulation11a_' + e.RecordFundInstitutionId).value;

    });

    this.onSaveFunds.emit(employee);

  }


  

  showRetirementGrantPayment() {
   
    let newIndex = this.employee.RetirementGrantPayments.length;
    if (newIndex==0) {
      if (this.getisRetirementGrantPayment) {
        this.addRetirementGrantPayment(null);
      }
    } else {
      // let lastIndex = this.employee.RetirementGrantPayments.length;
      // this.employee.RetirementGrantPayments = [];
      // for (let i = lastIndex-1; i >=0; i--) {
      //   this.employeeForm.removeControl('EntitledToBudgetPensionFromDate_' + i.toString());
      //   this.employeeForm.removeControl('EntitledToBudgetPensionSallary_' + i.toString());
      // }
    }
  }
  addRetirementGrantPayment(index) {
    if (index!=null) {
      let valueDate:Date = this.employeeForm.get('RetirementGrantPaymentsPaymentDate_' + index.toString()).value;
      let valueSallary:number = this.employeeForm.get('RetirementGrantPaymentsPayment_' + index.toString()).value;
      if (!valueDate || !valueSallary) {
        this.showMessage("error", "", "חובה למלא את תאריך וסכום התשלום");
        return;
      }
    }
    let newIndex = this.employee.RetirementGrantPayments.length;
    // let allowToAdd = true;
    // if (this.employee.RetirementGrantPayments && this.employee.RetirementGrantPayments.length > 0) {
    //   let lastItem = this.employee.RetirementGrantPayments[this.employee.RetirementGrantPayments.length-1];
    //   if (lastItem.Payment==null && lastItem.PaymentDate==null) {
    //     allowToAdd = false;
    //   }
    // }
    //if (allowToAdd) {
      this.employee.RetirementGrantPayments.push({
        Payment: null,
        PaymentDate: null
      });
      this.employeeForm.addControl('RetirementGrantPaymentsPaymentDate_' + newIndex.toString(), new FormControl(''));
      this.employeeForm.addControl('RetirementGrantPaymentsPayment_' + newIndex.toString(), new FormControl(''));
    //}
  }



  showContinuouslyWork() {
   
    let newIndex = this.employee.ContinuouslyWorks.length;
    if (newIndex==0) {
      if (!this.getisContinuouslyWork) {
        this.addContinuouslyWork(null);
      }
    } else {
      
    }
  }
  addContinuouslyWork(index) {
    if (index!=null) {
      let valueDateFrom:Date = this.employeeForm.get('ContinuouslyWorkPeriodFrom_' + index.toString()).value;
      let valueDateTo:Date = this.employeeForm.get('ContinuouslyWorkPeriodTo_' + index.toString()).value;
      let valueSallary:number = this.employeeForm.get('ContinuouslyWorkSallary_' + index.toString()).value;
      let valuePositionPercent:number = this.employeeForm.get('ContinuouslyWorkPositionPercent_' + index.toString()).value;
      if (!valueDateFrom || !valueDateTo || !valueSallary || !valuePositionPercent) {
        this.showMessage("error", "", "חובה למלא את כל הפרטים");
        return;
      }
    }
    let newIndex = this.employee.ContinuouslyWorks.length;
    // let allowToAdd = true;
    // if (this.employee.ContinuouslyWorks && this.employee.ContinuouslyWorks.length > 0) {
    //   let lastItem = this.employee.ContinuouslyWorks[this.employee.ContinuouslyWorks.length-1];
    //   if (lastItem.ContinuouslyWorkId==null && lastItem.PeriodFrom==null && lastItem.PeriodTo==null && lastItem.Sallary==null && lastItem.PositionPercent==null ) {
    //     allowToAdd = false;
    //   }
    // }
    //if (allowToAdd) {
      this.employee.ContinuouslyWorks.push({
        ContinuouslyWorkId: null,
        PeriodFrom: null,
        PeriodTo: null,
        Sallary: null,
        PositionPercent: null
      });
      this.employeeForm.addControl('ContinuouslyWorkPeriodFrom_' + newIndex.toString(), new FormControl(''));
      this.employeeForm.addControl('ContinuouslyWorkPeriodTo_' + newIndex.toString(), new FormControl(''));
      this.employeeForm.addControl('ContinuouslyWorkSallary_' + newIndex.toString(), new FormControl(''));
      this.employeeForm.addControl('ContinuouslyWorkPositionPercent_' + newIndex.toString(), new FormControl(''));
    //}
  }


  getStatusDesctiption() {
    if (this.employee.FormStatusId==this.enumFormalyStatus.Form161FormalyStatus_Draft) {
      return 'טיוטה';
    } else if (this.employee.FormStatusId==this.enumFormalyStatus.Form161FormalyStatus_OrderedAndWaitingForDataCompletition) {
      return 'הוזמן - ממתין להשלמת נתונים';
    } else if (this.employee.FormStatusId==this.enumFormalyStatus.Form161FormalyStatus_SentToFormaly) {
      return 'נשלח לפורמלי';
    } else if (this.employee.FormStatusId==this.enumFormalyStatus.Form161FormalyStatus_Finished) {
      return 'הסתיים';
    } else if (this.employee.FormStatusId==this.enumFormalyStatus.Form161FormalyStatus_Failed) {
      return 'נכשל';
    } else {
      return 'לא ידוע';
    }
  }

  getStatusColor() {
    if (this.employee.FormStatusId==this.enumFormalyStatus.Form161FormalyStatus_Draft) {
      return 'orange';
    } else if (this.employee.FormStatusId==this.enumFormalyStatus.Form161FormalyStatus_OrderedAndWaitingForDataCompletition) {
      return 'blue';
    } else if (this.employee.FormStatusId==this.enumFormalyStatus.Form161FormalyStatus_SentToFormaly) {
      return 'green';
    } else if (this.employee.FormStatusId==this.enumFormalyStatus.Form161FormalyStatus_Finished) {
      return 'black';
    } else if (this.employee.FormStatusId==this.enumFormalyStatus.Form161FormalyStatus_Failed) {
      return 'red';
    } else {
      return '';
    }
  }

  checkAllowedFor161Phase2() {
    if (this.employee.FormStatusId==this.enumFormalyStatus.Form161FormalyStatus_OrderedAndWaitingForDataCompletition) {
      if (this.userDetails && (this.userDetails.ClientRoleSupport || this.userDetails.ClientRoleAdministration  || this.userDetails.ClientRoleSemiAdministrator)) {
        if (this.userDetails.ClientRoleAdministration || this.userDetails.ClientRoleSemiAdministrator) {
          return true;
        } else {
          if (this.userDetails.UserName == this.customerAccountManagerEmail) {
            return true;
          } else {
            return false;
          }
        }
      } else {
        return false;
      }
    } else if (this.employee.FormStatusId==this.enumFormalyStatus.Form161FormalyStatus_SentToFormaly) {
      return true;
    } else if (this.employee.FormStatusId==this.enumFormalyStatus.Form161FormalyStatus_Finished) {
      return true;
    } else if (this.employee.FormStatusId==this.enumFormalyStatus.Form161FormalyStatus_Failed) {
      return true;
    } else {
      return false;
    }
  }


  isReadonly() {
    if (this.employee.FormStatusId != this.enumFormalyStatus.Form161FormalyStatus_Draft) {
      return true;
    } else {
      return false;
    }
  }

  isReadonlyPhase2() {
    if (this.employee.FormStatusId != this.enumFormalyStatus.Form161FormalyStatus_OrderedAndWaitingForDataCompletition) {
      return true;
    } else {
      return false;
    }
  }


  downloadForm161(): void {
    let fileName = this.employee.EmployeeTofesId + '.pdf';
    if (this.employee.FormalyFileReceived) {
      try {
        //this.showMessage('info', '', 'הקובץ יהיה מוכן בעוד מספר שניות');
        this.form161FormalyService.downloadForm161(this.employee.RecordId).subscribe((result: any) => {
          window.URL.createObjectURL(new Blob([result], { type: 'application/octet-stream' }));
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(result, fileName);
          }
          let url = window.URL.createObjectURL(result)
          let link = document.createElement('a');
          link.href = url;
          link.download = `${fileName}`;
          link.click();
        }, (err: HttpErrorResponse) => {
          this.showMessage('error', '', 'תקלה בהורדת הקובץ');
        });
      } catch (error) {
        this.showMessage('error', '', 'תקלה בהורדת הקובץ');
      }
    } else {
      this.showMessage('error', '', 'לא קיים קובץ');
    }
  }

  downloadXML(): void {
    let fileName = this.employee.EmployeeTofesId + '.xml';
    if (this.employee.FormStatusId>1) {
      try {
        //this.showMessage('info', '', 'הקובץ יהיה מוכן בעוד מספר שניות');
        this.form161FormalyService.downloadXML(this.employee.RecordId).subscribe((result: any) => {
          window.URL.createObjectURL(new Blob([result], { type: 'application/octet-stream' }));
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(result, fileName);
          }
          let url = window.URL.createObjectURL(result)
          let link = document.createElement('a');
          link.href = url;
          link.download = `${fileName}`;
          link.click();
        }, (err: HttpErrorResponse) => {
          this.showMessage('error', '', 'תקלה בהורדת הקובץ');
        });
      } catch (error) {
        this.showMessage('error', '', 'תקלה בהורדת הקובץ');
      }
    } else {
      this.showMessage('error', '', 'לא קיים קובץ');
    }
  }

  resetStatus() {
    this.form161FormalyService.resetStatus(this.employee.RecordId).subscribe((response) => {
      //this.employee.FormStatusId = this.enumFormalyStatus.Form161FormalyStatus_Draft;
      this.onReload.emit(this.employee);
    },
    (err: HttpErrorResponse) => {
      this.showMessage('error', '', 'תקלה בקבלת פרטי משתמש');
    });
  }

  onChangeCompletionCompensationHow(event) {
    if (this.getCompletionCompensationHow==null) {
      this.employeeForm.patchValue({
        CompletionCompensationPayingType: null,
        CompletionCompensationPayingCode: null,
        CompletionCompensationPayingName: null,
        CompletionCompensationTikNikuim: null,
        CompletionCompensationAmount: null,
        CompletionCompensationPaymentDate: null,
      });
    } else if (this.getCompletionCompensationHow=='מעסיק') {
      this.employeeForm.patchValue({
        CompletionCompensationPayingType: null,
        CompletionCompensationPayingCode: null,
        CompletionCompensationPayingName: this.dataForm161Header.CustomerName,
        CompletionCompensationTikNikuim: this.dataForm161Header.TikNikuim,
        CompletionCompensationAmount: null,
        CompletionCompensationPaymentDate: null,
      });
    } else if (this.getCompletionCompensationHow=='קופה מרכזית לפיצויים') {
      this.employeeForm.patchValue({
        CompletionCompensationPayingType: null,
        CompletionCompensationPayingCode: null,
        CompletionCompensationPayingName: null,
        CompletionCompensationTikNikuim: null,
        CompletionCompensationAmount: null,
        CompletionCompensationPaymentDate: null,
      });
    }
  }

  onChangeCompletionCompensationHow2(event) {
    if (this.getCompletionCompensationHow2==null) {
      this.employeeForm.patchValue({
        CompletionCompensationPayingType2: null,
        CompletionCompensationPayingCode2: null,
        CompletionCompensationPayingName2: null,
        CompletionCompensationTikNikuim2: null,
        CompletionCompensationAmount2: null,
        CompletionCompensationPaymentDate2: null,
      });
    } else if (this.getCompletionCompensationHow2=='מעסיק') {
      this.employeeForm.patchValue({
        CompletionCompensationPayingType2: null,
        CompletionCompensationPayingCode2: null,
        CompletionCompensationPayingName2: this.dataForm161Header.CustomerName,
        CompletionCompensationTikNikuim2: this.dataForm161Header.TikNikuim,
        CompletionCompensationAmount2: null,
        CompletionCompensationPaymentDate2: null,
      });
    } else if (this.getCompletionCompensationHow2=='קופה מרכזית לפיצויים') {
      this.employeeForm.patchValue({
        CompletionCompensationPayingType2: null,
        CompletionCompensationPayingCode2: null,
        CompletionCompensationPayingName2: null,
        CompletionCompensationTikNikuim2: null,
        CompletionCompensationAmount2: null,
        CompletionCompensationPaymentDate2: null,
      });
    }
  }


  datePrepare(d: Date) {
    if (d) {
      return new Date(d.getFullYear(), d.getMonth(), d.getDate(), 12, 0, 0);    // set 12 at noon for timezone issues
    } else {
      return d;
    }

  }

  deactivateEmployee(employee: Form161Employee) {
    this.confirmationService.confirm({
      message: 'האם ברצונך למחוק את הטופס?',
      accept: () => {
          this.form161FormalyService.deactivateEmployee(this.dataForm161Header.FormId, employee.RecordId).subscribe((result: void) => {
            window.location.href = '/form161List';
            
          }, (err: HttpErrorResponse) => {
            this.showMessage('error', '', 'תקלה במחיקת טופס');
          });
      }
    }); 
  }




  clone(obj) {
    return JSON.parse(JSON.stringify(obj));
  }


   

}





// WEBPACK FOOTER //
// C:/ProjectsOnGit/USilence/USilence/Client/src/app/form161-formaly-employee/form161-formaly-employee.component.ts